import React, { useState } from 'react';
import PrimaryButton from '../buttons/PrimaryButton.tsx';
import Cookie from '../../static/images/cookie.svg';
import { ButtonColor } from 'shared/buttons/models/ButtonModels';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(!localStorage.getItem('gdpr-consent'));
  const onConfirm = () => {
    localStorage.setItem('gdpr-consent', true);
    setIsVisible(false);
  };
  return (
    isVisible && (
      <div className="cookie-consent">
        <div className="w-10 h-10">
          <Cookie style={{ color: '#28277E' }} />
        </div>
        <div className="cookie-consent__text flex">
          <h5 className="text-white flex flex-col px-4 leading-snug">
            This website uses cookies.
            <a href="https://www.everviz.com/cookies/" className="text-white">
              Read more about our cookies here.
            </a>
          </h5>
          <PrimaryButton
            text="Got it!"
            onClick={() => onConfirm()}
            buttonColor={ButtonColor.Yellow}
            className="w-28 self-center"
          />
        </div>

        <i
          className="fa fa-close text-white absolute p-2.5 top-0 right-0 cursor-pointer"
          onClick={() => setIsVisible(false)}
        />
      </div>
    )
  );
};

export default CookieConsent;
